import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="TermsAndConditionsMain">
      <h1>Terms of Use Agreement</h1>
      <p>This Agreement was last revised on February 16, 2015.</p><br />
      <p>
        Welcome to Meylah.com, the website and online service of Meylah, Corp.
        (“Meylah” “we,” or “us”). This page explains the terms by which you may
        use our web site, web widgets, feeds, mobile device software
        applications (collectively, the “Meylah Software”), applications for
        third-party web sites and services, and any other mobile or web services
        or applications owned, controlled, or offered by Meylah (collectively
        the “Service”). By accessing or using the Service, you signify that you
        have read, understood, and agree to be bound by this Terms of Use
        Agreement (“Agreement”), whether or not you are a registered user of our
        Service.
      </p><br />
      <p>
        We reserve the right to amend this Agreement at any time by notifying
        you as provided in this Agreement, provided that no notice shall be
        required for non-substantive changes to the Agreement. If we amend this
        Agreement, we will give you at least seven (7) days notice before the
        changes take effect, during which period of time you may reject the
        changes by terminating your account. Your continued use of the Service
        after any such change constitutes your acceptance of the new Terms of
        Use. If you do not agree to any of these terms or any future Terms of
        Use, do not use or access (or continue to access) the Service. This
        Agreement applies to all visitors, users, Partners, and others who
        access the Service (“Users”). Partners are persons or entities that have
        executed a Launch Partner Agreement(s) with Meylah. If you are a
        Partner, this Agreement hereby incorporates by reference the Launch
        Partner Agreement between you and Meylah.
      </p><br />
      <h4>1. Use of Our Service</h4>
      <p>
        Meylah provides a comprehensive online platform for individuals and
        organizations to conduct their business, sell their products, share
        information, and teach their knowledge.<br /><br /> A Eligibility<br /><br /> This Service is
        intended solely for Users who are thirteen (13) years of age or older,
        and any registration, use or access to the Service by anyone under 13 is
        strictly prohibited and in violation of this Agreement. If you are under
        18 years of age you may use the Service only if you either are an
        emancipated minor or possess legal parental or guardian consent, and are
        fully able and competent to enter into the terms, conditions,
        obligations, affirmations, representations, and warranties set forth in
        this Agreement, and to abide by and comply with this Agreement. The
        Service is not available to any Users previously removed from the
        Service by Meylah.<br /><br /> B Member Accounts<br /><br /> You do not have to register in
        order to visit Meylah. To access certain features of the Service, you
        will need to register with Meylah and create a “Member” account. Your
        Member account gives you access to the services and functionality that
        we may establish and maintain from time to time and in our sole
        discretion. We may maintain different types of accounts for different
        types of Members. If you open a Member account on behalf of a company,
        organization, or other entity, then (a) “you” includes you and that
        entity, and (b) you represent and warrant that you are an authorized
        representative of the entity with the authority to bind the entity to
        this Agreement, and that you agree to this Agreement on the entity’s
        behalf. You may never use another Member’s account without permission.
        When creating your account, you must provide accurate and complete
        information including your full legal name, current address, a valid
        email address, and any other information needed in order to complete
        registration. You are solely responsible for the activity that occurs on
        your account, and you must keep your account password secure. You must
        notify Meylah immediately of any breach of security or unauthorized use
        of your account. Meylah will not be liable for any losses caused by any
        unauthorized use of your account. By providing Meylah your email address
        you consent to our using the email address to send you Service-related
        notices, including any notices required by law, in lieu of communication
        by postal mail. We may also use your email address to send you other
        messages, such as changes to features of the Service and special offers.
        If you do not want to receive such email messages, you may opt out by
        sending an email request to unsubscribe@meylah.com. Opting out may
        prevent you from receiving email messages regarding updates,
        improvements, or offers. You may cancel your account at anytime online
        at ww.meylah.com.
      </p>
    </div>
  );
};

export default TermsAndConditions;
